/**
 * Types for window.__ucCmp (Web CMP v3).
 * API reference: https://usercentrics.com/docs/web/features/api/control-functionality/
 */
import type { UcServiceId } from './usercentricsConfig';

export type ConsentType = 'EXPLICIT' | 'IMPLICIT';

export type UcServiceConsent = {
  given: boolean;
  type: ConsentType;
};

export type UcServiceData = {
  name?: string;
  consent?: UcServiceConsent;
  status?: boolean | { consented?: boolean };
};

export type UcConsentData = {
  status: 'ALL_ACCEPTED' | 'ALL_DENIED' | 'SOME_ACCEPTED' | 'SOME_DENIED';
  required: boolean;
  language: string;
  setting: {
    id: string;
    type: string;
    version: string;
  };
};

export type UcConsentDetails = {
  consent: UcConsentData;
  services: Record<UcServiceId | string, UcServiceData>;
};

export type UcCmpApi = {
  showFirstLayer: () => Promise<void>;
  showSecondLayer: (serviceId?: string) => Promise<void>;
  showServiceDetails: (serviceId: string) => Promise<void>;
  updateServicesConsents: (servicesConsents: { id: string; consent: boolean }[]) => Promise<void>;
  saveConsents: () => Promise<void>;
  getConsentDetails: () => Promise<UcConsentDetails>;
  changeLanguage: (countryCode: string) => Promise<void>;
  isInitialized: () => Promise<boolean>;
};

export type UcWindow = Window & {
  __ucCmp?: UcCmpApi;
};

export enum UcCmpEventType {
  ACCEPT_ALL = 'ACCEPT_ALL',
  CMP_SHOWN = 'CMP_SHOWN',
  DENY_ALL = 'DENY_ALL',
  IMPRINT_LINK = 'IMPRINT_LINK',
  MORE_INFORMATION_LINK = 'MORE_INFORMATION_LINK',
  PRIVACY_POLICY_LINK = 'PRIVACY_POLICY_LINK',
  SAVE = 'SAVE',
}

export type UcCmpEvent = CustomEvent<{
  source?: 'none' | 'button' | 'first' | 'second' | 'embeddings' | '__ucCmp';
  type?: UcCmpEventType;
}>;
